import i18n from '@/lang';
/* unplugin-vue-components disabled */
import { TabbarItem as __unplugin_components_5 } from 'vant/es';
import 'vant/es/tabbar-item/style/index';
import { TabbarItem as __unplugin_components_4 } from 'vant/es';
import 'vant/es/tabbar-item/style/index';
import { TabbarItem as __unplugin_components_3 } from 'vant/es';
import 'vant/es/tabbar-item/style/index';
import { TabbarItem as __unplugin_components_2 } from 'vant/es';
import 'vant/es/tabbar-item/style/index';
import { Tabbar as __unplugin_components_1 } from 'vant/es';
import 'vant/es/tabbar/style/index';
import { NavBar as __unplugin_components_0 } from 'vant/es';
import 'vant/es/nav-bar/style/index';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "mallApp"
  }, [_c(__unplugin_components_0, {
    attrs: {
      "title": i18n.tc("253"),
      "left-arrow": ""
    },
    on: {
      "click-left": _vm.onClickLeft
    }
  }), _c('router-view', {
    class: {
      'mall-router-active': _vm.ishow,
      'mall-router': true
    }
  }), _c(__unplugin_components_1, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.ishow,
      expression: "ishow"
    }],
    staticClass: "tabsBottom",
    attrs: {
      "route": ""
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: _vm.active,
      callback: function ($$v) {
        _vm.active = $$v;
      },
      expression: "active"
    }
  }, [_c(__unplugin_components_2, {
    attrs: {
      "replace": "",
      "to": "/serviceMall/home",
      "icon": "wap-home"
    }
  }, [_vm._v(i18n.tc("0"))]), _c(__unplugin_components_3, {
    attrs: {
      "replace": "",
      "to": "/serviceMall/classification",
      "icon": "column"
    }
  }, [_vm._v(i18n.tc("120"))]), _c(__unplugin_components_4, {
    attrs: {
      "replace": "",
      "to": "/serviceMall/shoppingCart",
      "icon": "cart"
    }
  }, [_vm._v(i18n.tc("121"))]), _c(__unplugin_components_5, {
    attrs: {
      "replace": "",
      "to": "/serviceMall/mine",
      "icon": "manager"
    }
  }, [_vm._v(i18n.tc("119"))])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };